/* eslint-disable */
import { getDataSource, getMe } from 'legacy/store/appReducer';
import { DATASOURCES } from 'legacy/constants';

// URL functions
import { fetchKardiaRxIdtfEcg, cctResendEosReport, cctCompletedCheckboxPatientDrawer, getEosEventsHistory, techCompletedEosReview, getEosStatus } from 'legacy/containers/ApiUrls';

// Constants Types
import ROUTE_PATHS from '../../../routes/routePaths';
import {
  CCT_PATIENT_HISTORY_DATA_REQUEST,
  CCT_PATIENT_HISTORY_DATA_SUCCESS,
  CCT_PATIENT_HISTORY_DATA_FAILURE,
  CCT_PATIENT_HISTORY_SELECTED_PATIENT,
  CCT_PATIENT_HISTORY_SELECTED_RECORDING,
  CCT_PATIENT_HISTORY_COMPLETED,
  CCT_RESEND_EOS_REPORT,
  CCT_FETCH_EVENT_HISTORY_REQUEST,
  CCT_FETCH_EVENT_HISTORY_SUCCESS,
  CCT_FETCH_EVENT_HISTORY_FAILURE,
  CCT_FETCH_EOS_REPORT_STATUS_REQUEST,
  CCT_FETCH_EOS_REPORT_STATUS_SUCCESS,
  CCT_FETCH_EOS_REPORT_STATUS_FAILURE,
} from './types';

import history from '../../../legacy/containers/History';

// ------------------------------------
// Actions
// ------------------------------------
export const kardiRxCctEcgTableDataRequest = () => ({
  type: CCT_PATIENT_HISTORY_DATA_REQUEST,
});
export const kardiRxCctEcgTableDataSuccess = data => ({
  type: CCT_PATIENT_HISTORY_DATA_SUCCESS,
  payload: data,
});
export const kardiRxCctEcgTableDataFailure = () => ({
  type: CCT_PATIENT_HISTORY_DATA_FAILURE,
});


// event history 
export const eventHistoryDataRequest = () => ({
  type: CCT_FETCH_EVENT_HISTORY_REQUEST,
});
export const eventHistoryDataSuccess = data => ({
  type: CCT_FETCH_EVENT_HISTORY_SUCCESS,
  payload: data,
});
export const eventHistoryDataFailure = () => ({
  type: CCT_FETCH_EVENT_HISTORY_FAILURE,
});


// eso report status
export const esoReportStatusRequest = () => ({
  type: CCT_FETCH_EOS_REPORT_STATUS_REQUEST,
});
export const esoReportStatusSuccess = data => ({
  type: CCT_FETCH_EOS_REPORT_STATUS_SUCCESS,
  payload: data,
});
export const esoReportStatusFailure = () => ({
  type: CCT_FETCH_EOS_REPORT_STATUS_FAILURE,
});


export const updateRxPatient = patient => ({
  type: CCT_PATIENT_HISTORY_SELECTED_PATIENT,
  payload: patient,
});

export const updateRxRecording = rec => ({
  type: CCT_PATIENT_HISTORY_SELECTED_RECORDING,
  payload: rec,
});

export const setInitialKardiaRxCCTEcgTableData = (match, location) => (
  dispatch,
  getState,
) => {
  const {
    participantId,
    connectionTemplateID,
  } = getState().kardiaRx.kardiaRxCCTPatientHistory.selectedPatinet;
  // const { patientId } = match.params;
  // const { search } = location;
  // const templetArr = search.split('templateID=');
  dispatch(
    updateRxPatient({
      participantId,
      connectionTemplateID,
    }),
  );
};

export const getKardiaRxCCTEcgHistory = (params, forceUpdate = false) => (
  dispatch,
  getState,
) => {
  dispatch(kardiRxCctEcgTableDataRequest());
  const meDataSource = getDataSource(getState(), DATASOURCES.ME);
  const kardiaRxCCTHistoryState = getState().kardiaRx.kardiaRxCCTPatientHistory
    .selectedPatinet;
    // console.log("kardiaRxCCTHistoryState=>", kardiaRxCCTHistoryState);
  let participantId;
  let connectionTemplateID;
  // console.log("params=>>", params);
  // work-list route
  if (
    kardiaRxCCTHistoryState &&
  //  kardiaRxCCTHistoryState.hasOwnProperty('connection_template_id')
    kardiaRxCCTHistoryState.hasOwnProperty('idtf_connection_id')
  ) {
    connectionTemplateID = kardiaRxCCTHistoryState.idtf_connection_id;
  }
  // Patient's recording list route
  else if (
    kardiaRxCCTHistoryState &&
    kardiaRxCCTHistoryState.hasOwnProperty('connectionTemplateID')
  ) {
    connectionTemplateID = kardiaRxCCTHistoryState.connectionTemplateID;
  }

  let promises;

  if (meDataSource.data && !forceUpdate) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }

  return promises
    .then(() => {
      const me = getDataSource(getState(), DATASOURCES.ME);
      const { teams } = me.data;
      const apiCalls = [];
      if(connectionTemplateID){
        apiCalls.push(
          dispatch(fetchKardiaRxIdtfEcg(connectionTemplateID)),
        );
      } else {
        apiCalls.push(
          dispatch(fetchKardiaRxIdtfEcg(params.idtf_connection_id)),
        );
      }
      
      return Promise.all(apiCalls);
    })
    .then(data => {
      return dispatch(kardiRxCctEcgTableDataSuccess(data));
    })
    .catch(err => {
      dispatch(kardiRxCctEcgTableDataFailure(err));
    });
};


export const getCCTEosEventsHistory = (params, forceUpdate = false) => (
  dispatch,
  getState,
) => {
  dispatch(eventHistoryDataRequest());
  const meDataSource = getDataSource(getState(), DATASOURCES.ME);
  const kardiaRxCCTHistoryState = getState().kardiaRx.kardiaRxCCTPatientHistory
    .selectedPatinet;
    // console.log("kardiaRxCCTHistoryState=>", kardiaRxCCTHistoryState);
  let participantId;
  let connectionTemplateID;
  // console.log("params=>>", params);
  // work-list route
  if (
    kardiaRxCCTHistoryState &&
  //  kardiaRxCCTHistoryState.hasOwnProperty('connection_template_id')
    kardiaRxCCTHistoryState.hasOwnProperty('idtf_connection_id')
  ) {
    connectionTemplateID = kardiaRxCCTHistoryState.idtf_connection_id;
  }
  // Patient's recording list route
  else if (
    kardiaRxCCTHistoryState &&
    kardiaRxCCTHistoryState.hasOwnProperty('connectionTemplateID')
  ) {
    connectionTemplateID = kardiaRxCCTHistoryState.connectionTemplateID;
  }

  let promises;

  if (meDataSource.data && !forceUpdate) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }

  return promises
    .then(() => {
      const me = getDataSource(getState(), DATASOURCES.ME);
      const { teams } = me.data;
      const apiCalls = [];
      if(connectionTemplateID){
        apiCalls.push(
          dispatch(getEosEventsHistory(connectionTemplateID)),
        );
      } else {
        apiCalls.push(
          dispatch(getEosEventsHistory(params.idtf_connection_id)),
        );
      }
      
      return Promise.all(apiCalls);
    })
    .then(data => {
      return dispatch(eventHistoryDataSuccess(data[0]));
    })
    .catch(err => {
      dispatch(eventHistoryDataFailure(err));
    });
};


export const getEosReportStatus = (params, forceUpdate = false) => (
  dispatch,
  getState,
) => {
  dispatch(esoReportStatusRequest());
  const meDataSource = getDataSource(getState(), DATASOURCES.ME);
  const kardiaRxCCTHistoryState = getState().kardiaRx.kardiaRxCCTPatientHistory
    .selectedPatinet;
    // console.log("kardiaRxCCTHistoryState=>", kardiaRxCCTHistoryState);
  let participantId;
  let connectionTemplateID;
  // console.log("params=>>", params);
  // work-list route
  if (
    kardiaRxCCTHistoryState &&
  //  kardiaRxCCTHistoryState.hasOwnProperty('connection_template_id')
    kardiaRxCCTHistoryState.hasOwnProperty('idtf_connection_id')
  ) {
    connectionTemplateID = kardiaRxCCTHistoryState.idtf_connection_id;
  }
  // Patient's recording list route
  else if (
    kardiaRxCCTHistoryState &&
    kardiaRxCCTHistoryState.hasOwnProperty('connectionTemplateID')
  ) {
    connectionTemplateID = kardiaRxCCTHistoryState.connectionTemplateID;
  }

  let promises;

  if (meDataSource.data && !forceUpdate) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }

  return promises
    .then(() => {
      const me = getDataSource(getState(), DATASOURCES.ME);
      const { teams } = me.data;
      const apiCalls = [];
      if(connectionTemplateID){
        apiCalls.push(
          dispatch(getEosStatus(connectionTemplateID)),
        );
      } else {
        apiCalls.push(
          dispatch(getEosStatus(params.idtf_connection_id)),
        );
      }
      
      return Promise.all(apiCalls);
    })
    .then(data => {
      return dispatch(esoReportStatusSuccess(data[0]));
    })
    .catch(err => {
       dispatch(esoReportStatusFailure(err));
    });
};

export const updatedSelectedKardiaRxPatient = data => dispatch => {
  dispatch(updateRxPatient(data));
};

export const updatedSelectedRxRecording = data => dispatch => {
  dispatch(updateRxRecording(data));
};


export const kardiaRxCctResendEosReport = (params, forceUpdate = false) => (
  dispatch,
  getState,
) => {
  const meDataSource = getDataSource(getState(), DATASOURCES.ME);

  let promises;

  if (meDataSource.data && !forceUpdate) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }

  return promises
    .then(() => {
      const me = getDataSource(getState(), DATASOURCES.ME);
      const apiCalls = [];
        apiCalls.push(
          dispatch(cctResendEosReport(params)),
        );
      
      return Promise.all(apiCalls);
    })
    .then(data => {
      return data
    })
    .catch(err => {
      return err
    });
};


export const kardiaRxCctCompletedCheckbox = (params, payload, forceUpdate = false) => (
  dispatch,
  getState,
) => {

  const meDataSource = getDataSource(getState(), DATASOURCES.ME);

  let promises;

  if (meDataSource.data && !forceUpdate) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }

  return promises
    .then(() => {
      const me = getDataSource(getState(), DATASOURCES.ME);
      const apiCalls = [];
        apiCalls.push(
          dispatch(techCompletedEosReview(params.idtf_connection_id, payload)),
        );
      
      return Promise.all(apiCalls);
    })
    .then(data => {
      dispatch(getCCTEosEventsHistory(params))
      dispatch(getEosReportStatus(params))
      // return data
    })
    .catch(err => {
      console.log("err=>>", err);
      // dispatch(kardiRxCctEcgTableDataFailure(err));
      return err
    });
};


// WEBPACK FOOTER //
// ./src/views/state/KardiaRxCCTPatientHistory/KardiaRxCCTPatientHistoryActions.js